import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IncomingGeneralContent, IncomingTransactionGeneral } from '@ui/src';
import { useAppSelector } from '@store';

import useProblemIncomingTransaction from '../hooks/use-incoming';

const ProblemIncomingGeneralContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.incoming,
  );
  const { pspAccounts, overdraftEnabled } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { currencies: currenciesList, paymentTypes } = useAppSelector(
    (state) => state.root,
  );

  const { transactionId } = useParams();

  const {
    getAccountBalanceAction,
    balanceIsLoading,
    pspPartnerBalanceisLoading,
    balanceIsFetching,
    pspPartnerBalanceisFetching,
    accountBalance,
    pspPartnerAccountBalance,
    balances,
    pspPartnerAccountBalanceInfo,
  } = useProblemIncomingTransaction({
    transaction,
    pspAccounts,
  });

  useEffect(() => {
    if (transaction) {
      getAccountBalanceAction();
    }
  }, [transaction]);

  return (
    <IncomingGeneralContent
      general={transaction as IncomingTransactionGeneral}
      transactionUrlType="incoming"
      transactionId={transactionId}
      currenciesList={currenciesList}
      withTransactionUrl
      isLoading={
        balanceIsLoading ||
        pspPartnerBalanceisLoading ||
        balanceIsFetching ||
        pspPartnerBalanceisFetching
      }
      accountBalance={accountBalance}
      currencyName={transaction?.currency?.name}
      pspPartnerAccountBalance={pspPartnerAccountBalance}
      pspPartnerName={
        pspAccounts?.find(
          (item) => item.pspPartner.id === transaction?.pspPartnerId,
        )?.pspPartner.companyName
      }
      recipientAccounts={[
        {
          name: transaction?.recipientAccount?.description,
          value: transaction?.recipientAccount?.fullNumber,
          suffix: transaction?.recipientAccount?.fullNumber,
        },
      ]}
      paymentsTypes={paymentTypes?.map((item) => ({
        name: item.name,
        value: item.paymentType,
      }))}
      overdraftEnabled={overdraftEnabled}
      recipientAccountsWithInfo={[transaction?.recipientAccount]}
      balances={balances}
      currencies={currenciesList?.map((item) => ({
        name: item.name,
        value: item.id,
      }))}
      currencyId={transaction?.currencyId}
      pspPartnersAccountsList={pspAccounts}
      pspPartnerAccountBalanceInfo={pspPartnerAccountBalanceInfo}
    />
  );
};

export default ProblemIncomingGeneralContentHOC;
